import { Dropdown } from 'antd';
import ThreeDotsIconHorizontal from 'components/atoms/icons/threeDotsIconHorizontal';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { ItemType } from 'antd/es/menu/interface';
import type { FC } from 'react';

type TItems = ItemType & { 'data-cy'?: string };

interface ActionsButtonProps {
  onEdit: () => void;
}

const ActionsButton: FC<ActionsButtonProps> = ({ onEdit }) => {
  const { t } = useTranslation();

  const items: TItems[] = [
    {
      label: t('controls.edit'),
      'data-cy': 'dropdown-edit-option',
      key: '1',
      onClick: onEdit,
    },
  ];

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      placement="bottomRight"
      rootClassName={s.menu}
    >
      <BaseButton
        onClick={(e) => e.preventDefault()}
        dataCy="switch-mode-dropdown-trigger"
        icon={<ThreeDotsIconHorizontal />}
        type="secondary"
      />
    </Dropdown>
  );
};
export default ActionsButton;
